import { render, staticRenderFns } from "./canteendailyreport.vue?vue&type=template&id=53f59ed6&"
import script from "./canteendailyreport.vue?vue&type=script&lang=js&"
export * from "./canteendailyreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports